export default value => {
  if (value === 'DRAFT') {
    return null;
  } if (value === 'ACTIVE') {
    return null;
  } if (value === 'ACTIVE_SEND') {
    return 'Send';
  } if (value === 'ACTIVE_OPEN') {
    return 'Open';
  } if (value === 'ACTIVE_RENDERING_FAILURE') {
    return 'Rendering Failure';
  } if (value === 'ACTIVE_REJECT') {
    return 'Reject';
  } if (value === 'ACTIVE_DELIVERY') {
    return 'Delivery';
  } if (value === 'ACTIVE_BOUNCE') {
    return 'Bounce';
  } if (value === 'ACTIVE_COMPLAINT') {
    return 'Complaint';
  } if (value === 'ACTIVE_DELIVERY_DELAY') {
    return 'Delivery Delay';
  } if (value === 'ACTIVE_SUBSCRIPTION') {
    return 'Subscription';
  } if (value === 'ACTIVE_CLICK') {
    return 'Click';
  } if (value === 'PAST_DUE') {
    return null;
  } if (value === 'PAST_DUE_SEND') {
    return 'Send';
  } if (value === 'PAST_DUE_OPEN') {
    return 'Open';
  } if (value === 'PAST_DUE_RENDERING_FAILURE') {
    return 'Rendering Failure';
  } if (value === 'PAST_DUE_REJECT') {
    return 'Reject';
  } if (value === 'PAST_DUE_DELIVERY') {
    return 'Delivery';
  } if (value === 'PAST_DUE_BOUNCE') {
    return 'Bounce';
  } if (value === 'PAST_DUE_COMPLAINT') {
    return 'Complaint';
  } if (value === 'PAST_DUE_DELIVERY_DELAY') {
    return 'Delivery Delay';
  } if (value === 'PAST_DUE_SUBSCRIPTION') {
    return 'Subscription';
  } if (value === 'PAST_DUE_CLICK') {
    return 'Click';
  } if (value === 'CANCELLED') {
    return null;
  } if (value === 'CANCELLED_SEND') {
    return 'Send';
  } if (value === 'CANCELLED_OPEN') {
    return 'Open';
  } if (value === 'CANCELLED_RENDERING_FAILURE') {
    return 'Rendering Failure';
  } if (value === 'CANCELLED_REJECT') {
    return 'Reject';
  } if (value === 'CANCELLED_DELIVERY') {
    return 'Delivery';
  } if (value === 'CANCELLED_BOUNCE') {
    return 'Bounce';
  } if (value === 'CANCELLED_COMPLAINT') {
    return 'Complaint';
  } if (value === 'CANCELLED_DELIVERY_DELAY') {
    return 'Delivery Delay';
  } if (value === 'CANCELLED_SUBSCRIPTION') {
    return 'Subscription';
  } if (value === 'CANCELLED_CLICK') {
    return 'Click';
  } if (value === 'INCOMPLETE') {
    return 'Incomplete';
  } if (value === 'INCOMPLETE_SEND') {
    return 'Send';
  } if (value === 'INCOMPLETE_OPEN') {
    return 'Open';
  } if (value === 'INCOMPLETE_RENDERING_FAILURE') {
    return 'Rendering Failure';
  } if (value === 'INCOMPLETE_REJECT') {
    return 'Reject';
  } if (value === 'INCOMPLETE_DELIVERY') {
    return 'Delivery';
  } if (value === 'INCOMPLETE_BOUNCE') {
    return 'Bounce';
  } if (value === 'INCOMPLETE_COMPLAINT') {
    return 'Complaint';
  } if (value === 'INCOMPLETE_DELIVERY_DELAY') {
    return 'Delivery Delay';
  } if (value === 'INCOMPLETE_SUBSCRIPTION') {
    return 'Subscription';
  } if (value === 'INCOMPLETE_CLICK') {
    return 'Click';
  } if (value === 'FAILED') {
    return 'Failed';
  } if (value === 'FAILED_SEND') {
    return 'Send';
  } if (value === 'FAILED_OPEN') {
    return 'Open';
  } if (value === 'FAILED_RENDERING_FAILURE') {
    return 'Rendering Failure';
  } if (value === 'FAILED_REJECT') {
    return 'Reject';
  } if (value === 'FAILED_DELIVERY') {
    return 'Delivery';
  } if (value === 'FAILED_BOUNCE') {
    return 'Bounce';
  } if (value === 'FAILED_COMPLAINT') {
    return 'Complaint';
  } if (value === 'FAILED_DELIVERY_DELAY') {
    return 'Delivery Delay';
  } if (value === 'FAILED_SUBSCRIPTION') {
    return 'Subscription';
  } if (value === 'FAILED_CLICK') {
    return 'Click';
  } if (value === 'PARTIALLY_PAID') {
    return 'Partially Paid';
  } if (value === 'PARTIALLY_PAID_SEND') {
    return 'Send';
  } if (value === 'PARTIALLY_PAID_OPEN') {
    return 'Open';
  } if (value === 'PARTIALLY_PAID_RENDERING_FAILURE') {
    return 'Rendering Failure';
  } if (value === 'PARTIALLY_PAID_REJECT') {
    return 'Reject';
  } if (value === 'PARTIALLY_PAID_DELIVERY') {
    return 'Delivery';
  } if (value === 'PARTIALLY_PAID_BOUNCE') {
    return 'Bounce';
  } if (value === 'PARTIALLY_PAID_COMPLAINT') {
    return 'Complaint';
  } if (value === 'PARTIALLY_PAID_DELIVERY_DELAY') {
    return 'Delivery Delay';
  } if (value === 'PARTIALLY_PAID_SUBSCRIPTION') {
    return 'Subscription';
  } if (value === 'PARTIALLY_PAID_CLICK') {
    return 'Click';
  } if (value === 'OVERDUE_FEE_CHARGED') {
    return 'Overdue Fee';
  } if (value === 'PAID') {
    return null;
  } return null;
};
